import React, { useEffect, useState } from 'react';
import { BiCheckbox, BiCheckboxChecked, BiCheckboxMinus } from 'react-icons/bi';

import SearchSubregionsDropdownList from './SearchSubregionsDropdownList';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';

const SearchRegionsDropdownList = ({ onChoose, item, value, subvalue, titleCss = '' }) => {
  const [isShow, setIsShow] = useState(false);
  const [isAnyItemChosen, setAnyItemsChosen] = useState(false);

  useEffect(() => {
    if (Array.isArray(item.subitems)) {
      setAnyItemsChosen(
        item.subitems.some((subitem) => subvalue.includes(subitem.id))
      );
    }
  }, [subvalue]);

  let isItemChosen = value.includes(item.id);

  const toggleShowHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsShow(!isShow);
  };
  return (
    <>
      <div
        className={`group__title group__title_multi${
          isAnyItemChosen || isItemChosen ? ' group__title_chosen' : ''
        }${titleCss}`}
      >
        {isItemChosen ? (
          <BiCheckboxChecked />
        ) : isAnyItemChosen ? (
          <BiCheckboxMinus />
        ) : (
          <BiCheckbox />
        )}
        {item.name}
        {item?.subitems?.length ? (
          <button onClick={toggleShowHandler}>
            {isShow ? (
              <AiOutlineMinusCircle color="#fb089b" />
            ) : (
              <AiOutlinePlusCircle />
            )}
          </button>
        ) : null}
      </div>
      <div className={`group__items${isShow ? ' group__items_opened' : ''}`}>
        {item.subitems?.length && isShow ? (
          <SearchSubregionsDropdownList
            value={subvalue}
            onChoose={onChoose}
            isOpen={true}
            items={item.subitems}
          />
        ) : null}
      </div>
    </>
  );
};

export default SearchRegionsDropdownList;
